import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 15, 15),
}));
export const StyledNewPaymentMethodItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(8),
  border: `${theme.spacing(0.5)} solid ${theme.palette.grey[400]}`,
  marginTop: theme.spacing(10),
  '.payment-type': {
    display: 'flex',
    alignItems: 'center',
  },
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
    cursor: 'pointer',
  },
}));
